/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  HTTPValidationError,
  PlanLabelPositionDTO,
  PlanLabelPositionModifyDTO,
} from '../fastAPI.schemas'

/**
 * @summary Get Plan Label Positions
 */
export const getPlanLabelPositions = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<PlanLabelPositionDTO[]>({
    url: `/projects/${projectGuid}/plan-label-positions`,
    method: 'GET',
    signal,
  })
}

export const getGetPlanLabelPositionsQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/plan-label-positions`] as const
}

export const getGetPlanLabelPositionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanLabelPositions>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPlanLabelPositions>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPlanLabelPositionsQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanLabelPositions>>> = ({ signal }) =>
    getPlanLabelPositions(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanLabelPositions>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetPlanLabelPositionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanLabelPositions>>
>
export type GetPlanLabelPositionsQueryError = HTTPValidationError

/**
 * @summary Get Plan Label Positions
 */

export function useGetPlanLabelPositions<
  TData = Awaited<ReturnType<typeof getPlanLabelPositions>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getPlanLabelPositions>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlanLabelPositionsQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Delete Plan Label Position
 */
export const deletePlanLabelPosition = (projectGuid: string, elementGuid: string) => {
  return customInstance<void>({
    url: `/projects/${projectGuid}/plan-label-positions/${elementGuid}`,
    method: 'DELETE',
  })
}

export const useDeletePlanLabelPositionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlanLabelPosition>>,
    TError,
    { projectGuid: string; elementGuid: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlanLabelPosition>>,
  TError,
  { projectGuid: string; elementGuid: string },
  TContext
> => {
  const mutationKey = ['deletePlanLabelPosition']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlanLabelPosition>>,
    { projectGuid: string; elementGuid: string }
  > = props => {
    const { projectGuid, elementGuid } = props ?? {}

    return deletePlanLabelPosition(projectGuid, elementGuid)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/plan-label-positions/{elementGuid}` },
    {
      operationId:
        'delete_plan_label_position_projects__project_guid__plan_label_positions__element_guid__delete',
      operationName: 'deletePlanLabelPosition',
    },
  )

  return customOptions
}

export type DeletePlanLabelPositionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlanLabelPosition>>
>

export type DeletePlanLabelPositionMutationError = HTTPValidationError

/**
 * @summary Delete Plan Label Position
 */
export const useDeletePlanLabelPosition = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlanLabelPosition>>,
    TError,
    { projectGuid: string; elementGuid: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePlanLabelPosition>>,
  TError,
  { projectGuid: string; elementGuid: string },
  TContext
> => {
  const mutationOptions = useDeletePlanLabelPositionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Set Plan Label Position
 */
export const setPlanLabelPosition = (
  projectGuid: string,
  elementGuid: string,
  planLabelPositionModifyDTO: PlanLabelPositionModifyDTO,
) => {
  return customInstance<PlanLabelPositionDTO>({
    url: `/projects/${projectGuid}/plan-label-positions/${elementGuid}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: planLabelPositionModifyDTO,
  })
}

export const useSetPlanLabelPositionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPlanLabelPosition>>,
    TError,
    { projectGuid: string; elementGuid: string; data: PlanLabelPositionModifyDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setPlanLabelPosition>>,
  TError,
  { projectGuid: string; elementGuid: string; data: PlanLabelPositionModifyDTO },
  TContext
> => {
  const mutationKey = ['setPlanLabelPosition']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setPlanLabelPosition>>,
    { projectGuid: string; elementGuid: string; data: PlanLabelPositionModifyDTO }
  > = props => {
    const { projectGuid, elementGuid, data } = props ?? {}

    return setPlanLabelPosition(projectGuid, elementGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/plan-label-positions/{elementGuid}` },
    {
      operationId:
        'set_plan_label_position_projects__project_guid__plan_label_positions__element_guid__put',
      operationName: 'setPlanLabelPosition',
    },
  )

  return customOptions
}

export type SetPlanLabelPositionMutationResult = NonNullable<
  Awaited<ReturnType<typeof setPlanLabelPosition>>
>
export type SetPlanLabelPositionMutationBody = PlanLabelPositionModifyDTO
export type SetPlanLabelPositionMutationError = HTTPValidationError

/**
 * @summary Set Plan Label Position
 */
export const useSetPlanLabelPosition = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPlanLabelPosition>>,
    TError,
    { projectGuid: string; elementGuid: string; data: PlanLabelPositionModifyDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setPlanLabelPosition>>,
  TError,
  { projectGuid: string; elementGuid: string; data: PlanLabelPositionModifyDTO },
  TContext
> => {
  const mutationOptions = useSetPlanLabelPositionMutationOptions(options)

  return useMutation(mutationOptions)
}
